import claimOptions from './constants/claimOptions';

export const claimLookup = {
    claimOptions: claimOptions
};